import { gql } from '@apollo/client';

import { stimulusResourceFragment } from 'approot/shared/stimulus/stimulus.graphql';
import { interactiveLessonSectionComponentFragment } from 'approot/activity-builder/lesson-builder.graphql';

export const ATTACH_STIMULUS_RESOURCE = gql`
  mutation AttachStimulusResource($input: AttachStimulusResourceInput!) {
    attachStimulusResource(input: $input) {
      ...StimulusResource
    }
  }
  ${stimulusResourceFragment}
`;

export const ADD_IMAGE_TO_STIMULUS = gql`
  mutation AddImageToStimulus($input: AddImageToStimulusLibraryInput!) {
    addImageToStimulusLibrary(input: $input) {
      ...InteractiveLessonSectionComponent
    }
  }
  ${interactiveLessonSectionComponentFragment}
`;

export const CREATE_STIMULUS_RESOURCE = gql`
  mutation CreateStimulusResource($input: CreateStimulusResourceInput!) {
    createStimulusResource(input: $input) {
      ...StimulusResource
    }
  }
  ${stimulusResourceFragment}
`;

export const UPDATE_STIMULUS_RESOURCE = gql`
  mutation UpdateStimulusResource($input: UpdateStimulusResourceInput!) {
    updateStimulusResource(input: $input) {
      ...StimulusResource
    }
  }
  ${stimulusResourceFragment}
`;

export const GET_STIMULUS_LESSON = gql`
  query GetStimulusLesson($input: GetLessonByIdInput!) {
    getLessonById(input: $input) {
      id
      slug
      subjects {
        name
      }
      years {
        name
      }
    }
  }
`;

export const GET_STIMULUS_ASSESSMENT = gql`
  query GetStimulusAssessment($input: GetAssessmentByIdInput!) {
    getAssessmentById(input: $input) {
      id
      slug
      subjects {
        name
      }
      years {
        name
      }
    }
  }
`;
